import useTranslation from './useTranslation';
import { toast } from 'sonner';

interface NotificationProps {
	title?: string;
	content: string;
	theme?: 'success' | 'danger' | 'info' | 'warning';
	id?: number | string;
}

const useNotification = () => {
	const { t } = useTranslation();

	const showNotificationSuccess = (args: NotificationProps) =>
		toast.success(t(args.content), { id: args.id });

	const showNotificationAlert = (args: NotificationProps) =>
		toast.error(t(args.content), { id: args.id });

	const showNotificationWarning = (args: NotificationProps) =>
		toast.warning(t(args.content), { id: args.id });

	const showNotificationLoading = (args: NotificationProps) =>
		toast.loading(t(args.content), { id: args.id, duration: Infinity });

	const dismissNotification = (id?: number | string) => toast.dismiss(id);

	return {
		showNotificationSuccess,
		showNotificationAlert,
		showNotificationWarning,
		showNotificationLoading,
		dismissNotification,
	};
};

export default useNotification;
